export default __webpack_public_path__ + "static/media/residencial_15.7383b6d7.png";